<template>
	<div style="height: 100%;">
		<page v-if="$route.path === '/TravelInfo/Notice'">
			<listTemplate page-title="List" :pid="$cid.english.notice" :page-size="6" type="list"
				@article-click="articleClick"></listTemplate>

		</page>
		<router-view v-else></router-view>
	</div>
</template>
<script>
	import listTemplate from "~/components/entemplate/listTemplate.vue";

	export default {
		components: {
			listTemplate
		},
		data() {
			return {
				pid: null,
			}
		},
		methods: {
			articleClick(item) {
				this.$openNewWindow('/new/TravelInfo/Notice/NoticeDetail?id=' + item.id);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/english/TravelInfo/Notice.vue